/**
 * App configuration constants
 *
 * Contains environment-aware settings for Shopify app integration,
 * particularly for theme extension deep linking.
 */
export const APP_CONFIG = {
  // Client IDs from shopify.app.toml files
  // These are used for deep linking to the theme editor
  CLIENT_ID: {
    production: '153a577aba713b3e50c43fc82c0b9881',
    development: '520c1948d29d2ffe86823e7f2cfe8b6b',
  },

  // Theme extension block handle (Liquid filename without .liquid extension)
  // This must match the filename in extensions/.../blocks/
  THEME_EXTENSION_HANDLE: 'campaigns-tracker',

  /**
   * Build deep link URL for theme extension activation
   *
   * Deep linking is Shopify's official pattern for app embed block activation.
   * The URL opens the theme editor with the extension pre-activated.
   * Merchant just needs to click "Save" to enable.
   *
   * @param {string} myshopifyDomain - e.g., "my-store.myshopify.com"
   * @returns {string} Deep link URL to theme editor
   *
   * @example
   * const url = APP_CONFIG.getThemeExtensionDeepLink('my-store.myshopify.com');
   * // Returns: https://my-store.myshopify.com/admin/themes/current/editor?context=apps&activateAppId=...
   */
  getThemeExtensionDeepLink: (myshopifyDomain) => {
    // Determine environment based on hostname
    // Development Gadget apps use --development subdomain
    const isDev = window.location.hostname.includes('development');

    const clientId = isDev
      ? APP_CONFIG.CLIENT_ID.development
      : APP_CONFIG.CLIENT_ID.production;

    // Shopify deep link format for app embed blocks
    // See: https://shopify.dev/docs/apps/build/online-store/theme-app-extensions/configuration#deep-linking
    return `https://${myshopifyDomain}/admin/themes/current/editor?context=apps&activateAppId=${clientId}/${APP_CONFIG.THEME_EXTENSION_HANDLE}`;
  }
};
